module.exports = __webpack_public_path__ + "static/media/bg_white.7a996e41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/utils/images/originals/bg_white.jpg
// module id = 129
// module chunks = 0